(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySubscriptionHistoriesController', CompanySubscriptionHistoriesController);

    CompanySubscriptionHistoriesController.$inject = ['$scope', '$state', 'CompanySubscriptionStatusCustom', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', '$stateParams'];

    function CompanySubscriptionHistoriesController($scope, $state, CompanySubscriptionStatusCustom, ParseLinks, AlertService, pagingParams, paginationConstants, $stateParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.searchKeyPress = searchKeyPress;
        vm.clearSearch = clearSearch;
        vm.filterQuery = {};
        vm.packageType = $stateParams.packageType;
        vm.filterQuery.packageType = vm.packageType;


        //must set in cache
        vm.pageSize = 10;
        vm.pageSizeList = [10, 20, 50];
        vm.isSearching = false;
        vm.pageSizeChanged = pageSizeChanged;

        vm.back = back;


        loadData();

        // loadAll_paging();


        function loadData() {
            filter();
        }

        // function loadAll_paging() {
        //
        //     if (pagingParams.search) {
        //         CompanyCustomerDataSearch.query({
        //             query: pagingParams.search,
        //             page: pagingParams.page - 1,
        //             size: paginationConstants.itemsPerPage,
        //             sort: sort()
        //         }, onSuccess, onError);
        //     } else {
        //         CompanyCustomerDataSearch.query({
        //             query: "",
        //             page: pagingParams.page - 1,
        //             size: paginationConstants.itemsPerPage,
        //             sort: sort()
        //         }, onSuccess, onError);
        //     }
        //
        //     function sort() {
        //         var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        //         if (vm.predicate !== 'id') {
        //             result.push('id');
        //         }
        //         return result;
        //     }
        //
        //     function onSuccess(data, headers) {
        //         vm.links = ParseLinks.parse(headers('link'));
        //         vm.totalItems = headers('X-Total-Count');
        //         vm.queryCount = vm.totalItems;
        //         vm.CompanyCustomerDatas = data;
        //         vm.page = pagingParams.page;
        //     }
        //
        //     function onError(error) {
        //         AlertService.error(error.data.message);
        //     }
        // }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            // $state.transitionTo($state.$current, {
            //     page: vm.page,
            //     sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            //     search: vm.currentSearch
            // });
            if (vm.filterQuery.searchMode)
                getPagesByQuery(vm.filterQuery);
            else
                getPagesByQuery();

        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.filterQuery.pageNumber = 0;
            vm.transition();
        }


        function search() {

            // loadAll_paging();
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = vm.searchQuery;
            vm.transition();

        }


        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                vm.advancedSearch();
            }
        }


        function clearSearch() {
            vm.filterQuery.searchText = null;
            filter_Global();
        }


        vm.advancedSearch = function () {
            clear();
            vm.filterQuery.searchMode = true;
            filter();
        }

        function pageSizeChanged() {
            clear();
            filter();
        }

        function getPagesByQuery(customFilter) {

            if (vm.isSearching)
                return;

            vm.isSearching = true;
            var filterQuery = vm.filterQuery;
            if (customFilter)
                filterQuery = customFilter;

            if (vm.page)
                filterQuery.pageNumber = vm.page - 1;
            else
                filterQuery.pageNumber = 0;


            filterQuery.pageSize = vm.pageSize; // paginationConstants.itemsPerPage;
            // paginationConstants.itemsPerPage = vm.pageSize;

            CompanySubscriptionStatusCustom.searchCompanySubscriptionStatusByQueryPage().save(filterQuery, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companySubscriptionStatuses = data;
                vm.isSearching = false;

                gotToTop();

            }

            function onError(error) {
                vm.isSearching = false;
                AlertService.error(error.data.message);
            }
        }


        function gotToTop() {
            // window.scroll(0, 0);
            if (vm.page > 1) {
                document.getElementsByClassName("topOfList")[0].scrollIntoView();
                document.getElementsByClassName("topOfListMobile")[0].scrollIntoView();
            }
        }

        function filter_Global() {
            vm.filterQuery.searchMode = true;
            filter();
            clear();

        }

        function filter(customFilter) {

            if (vm.isSearching)
                return;
            getPagesByQuery(customFilter);
        }

        function back() {
            if (vm.packageType && vm.packageType == 'SMS')
                $state.transitionTo('supplierPanel-v2.companySmsPackageStatus');
            else
                $state.transitionTo('supplierPanel-v2.companySubscriptionStatusV2');
        }


    }
})();
